/**
 * @since 2025-02-19
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import TableScheduler from "./TableScheduler";

export default TableScheduler;
